<template>
  <layout-default-filters @apply="$_applyQueryString">
    <template #superior>
      <v-form ref="form">
        <core-date-picker-field
          v-model="filters.createdFrom"
          clearable
          label="De"
        />

        <core-date-picker-field
          v-model="filters.createdBefore"
          clearable
          label="Até"
          :rules="createdBeforeRules"
        />
      </v-form>
    </template>
  </layout-default-filters>
</template>

<script>
import { mapMutations } from 'vuex';

import { CADASTRO_PEDIDO_PRODUTO_QUERIES } from '@/constants/QUERY_FILTERS';

import { getQueryValue, setQueryValue } from '@/services/query-string';
import LayoutDefaultFilters from '@/layouts/default/NewFilters.vue';
import CoreDatePickerField from '@/components/core/date-picker-field/Index.vue';

export default {
  name: 'ViewVendasFilters',

  components: {
    LayoutDefaultFilters,
    CoreDatePickerField,
  },

  data() {
    const dataAtual = new Date();
    const hoje = dataAtual.toISOString().split('T')[0];
    
    const ano = dataAtual.getFullYear();
    const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    const primeiroDiaMes = `${ano}-${mes}-01`;

    return {
      filters: {
        createdFrom: primeiroDiaMes,
        createdBefore: hoje,
      },
      createdBeforeRules: [
        () => new Date(this.filters.createdBefore) >= new Date(this.filters.createdFrom)
          || 'Data Final deve ser superior a Data Inicial',
      ],
    };
  },

  mounted() {
    if (!this.$route.query[CADASTRO_PEDIDO_PRODUTO_QUERIES.createdFrom]) {
      this.$_applyQueryString();
    }
  },

  methods: {
    ...mapMutations({
      $_setRefresh: 'filter/refresh',
    }),

    $_applyQueryString() {
      setQueryValue(CADASTRO_PEDIDO_PRODUTO_QUERIES.createdFrom, this.filters.createdFrom);
      setQueryValue(CADASTRO_PEDIDO_PRODUTO_QUERIES.createdBefore, this.filters.createdBefore);
      this.$_setRefresh('S');
    },
  },

  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler() {
        const dataAtual = new Date();
        const hoje = dataAtual.toISOString().split('T')[0];
        
        const ano = dataAtual.getFullYear();
        const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
        const primeiroDiaMes = `${ano}-${mes}-01`;

        this.filters.createdFrom = getQueryValue(CADASTRO_PEDIDO_PRODUTO_QUERIES.createdFrom, primeiroDiaMes);
        this.filters.createdBefore = getQueryValue(CADASTRO_PEDIDO_PRODUTO_QUERIES.createdBefore, hoje);
      },
    },
  },
};
</script>

<style scoped></style>